import * as React from 'react'
import { ComponentExt } from '@utils/reactExt'
import * as styles from './style/index.scss'
import DotTitle from '@componentsG/dotTitle'
import { FormattedMessage, FormattedPlural } from 'react-intl'
import moment from 'moment'
import { DATE_UNIT_V, GOODS_OPERATOR_TYPE_V, OPERATOR_V } from '@src/constants';
import { countTotalFlowData, filterFlowUnit, formatDate } from '@src/utils'
import IconUsing from '@assets/img/global/icon_using.png'
import { WingBlank } from 'antd-mobile'
import intl from '@utils/intl';
import MultiActivity from '@utils/multiActivity';

interface FlowUseProps {
    simInfo: any
    refuelPackageOrderRecord: any  // 当月加油包记录
    refuelPackageEndDate: any  // 当月加油包记录
}

class FlowUse extends ComponentExt<FlowUseProps> {
    constructor(props) {
        super(props)
    }

    // 本月最后一天
    getCurrentMonthLast = () => {
        return moment().endOf('month');
    }
    getCloseCycleEnd = (startDate, timeUnit, timeLength) => {
        let currentCycleEnd = moment(startDate).add(Number(timeLength), timeUnit === DATE_UNIT_V.DAY ? 'days' : 'months')
        const loop = () => {
            if (moment().isBefore(currentCycleEnd)) {
                return currentCycleEnd
            } else {
                currentCycleEnd = moment(currentCycleEnd).add(Number(timeLength), timeUnit === DATE_UNIT_V.DAY ? 'days' : 'months')
                loop()
            }
        }
        loop()
        return currentCycleEnd
    }

    calcLeftDays = (startDate, timeUnit, timeLength) => {
        switch (this.props.simInfo.goodsOperatorType) {
            case GOODS_OPERATOR_TYPE_V.MONTHPAID:
                return moment(this.getCurrentMonthLast()).diff(moment(), 'day')
            case GOODS_OPERATOR_TYPE_V.PREPAID:
                return moment(this.getCloseCycleEnd(startDate, timeUnit, timeLength)).diff(moment(), 'day')
            default:
                return moment(this.getCurrentMonthLast()).diff(moment(), 'day')
        }
    }

    render() {
        const simInfo = this.props.simInfo
        if (JSON.stringify(simInfo) === '{}') {
            return <></>
        }
        const {
            policyDegree, goodsNumber
        } = simInfo
        const multiActivity = new MultiActivity(simInfo)
        const unit = multiActivity.formatPackageValidDate().unit
        const goodsTime = multiActivity.formatPackageValidDate().goodsTime
        const preMonth = intl.formatMessage({ id: 'common.unitMonthOdd' })
        const leftTime = this.calcLeftDays(simInfo.startDate, simInfo.timeUnit, simInfo.timeLength)
        const restFlow = Number(simInfo.quantityMax) - Number(simInfo.monthUsage || 0)
        const usePercent = (Number(simInfo.quantityMax) === 0 || simInfo.totalCount == '-1') ? 0 : Number(simInfo.monthUsage || 0) / Number(simInfo.quantityMax) * 100
        const leftTimesBoxLeft = 50
        const addFlow = Number(simInfo.quantityMax) - Number(simInfo.policyDegree)
        if (simInfo.outDate || simInfo.stop || !simInfo.startDate) {
            return <></>
        }
        return (
            <>
                <p className={styles.flowUseTitle}>
                    <FormattedMessage id="home.flowUse.title" />
                </p>
                <DotTitle messageId="home.flowUse.status.title" />
                {/*流量使用百分比*/}
                <section className={styles.usedInfoWrap}>
                    <div className={styles.flexBetween}>
                        <span className={styles.useTitle} style={{ color: '#eb6a1a' }}>
                            <FormattedMessage id="home.flowUse.status.used" />
                        </span>
                        <span className={styles.useTitle} style={{ color: '#1B334C' }}>
                            <FormattedMessage id="home.flowUse.status.remaining" />
                        </span>
                    </div>
                    <div className={styles.flexBetween} style={{ marginTop: 3 }}>
                        <span className={styles.useNum} style={{ color: '#eb6a1a' }}>
                            {filterFlowUnit(simInfo.monthUsage || 0, true).value}
                            {filterFlowUnit(simInfo.monthUsage || 0, true).unit}
                        </span>
                        {simInfo.totalCount == '-1' ? <span className={styles.useNum} style={{ color: '#1B334C' }}>
                            {<FormattedMessage id="home.flowUse.status.unlimited" />}
                        </span> : <span className={styles.useNum} style={{ color: '#1B334C' }}>
                            {filterFlowUnit(restFlow, true).value}
                            {filterFlowUnit(restFlow, true).unit}
                        </span>}
                    </div>
                    {
                        simInfo.totalCount != '-1' && <p className={styles.totalNum}>
                            {
                                /*simInfo.quantityMax - simInfo.policyDegree > 0 &&*/
                                <>
                                    <span style={{ color: '#1B334C' }}>{`(${filterFlowUnit(simInfo.policyDegree)}`}</span>
                                    <span style={{ color: '#EB6A1A' }}>{`+${filterFlowUnit(addFlow > 0 ? addFlow : 0)})`}</span>
                                </>
                            }
                        </p>
                    }

                    <div className={styles.usedProgressOutWrap}>
                        <div className={styles.usedProgressInnerWrap} style={{ width: `${usePercent.toFixed(2)}%` }} />
                    </div>
                    <div className={styles.leftDays} style={{ left: `calc(${leftTimesBoxLeft}% - 43px)` }}>
                        <span className={styles.triangle} />
                        <span className={styles.text}>
                            <FormattedMessage
                                id="home.flowUse.leftDay"
                                values={{
                                    day: leftTime,
                                    unit: <FormattedPlural
                                        value={Number(leftTime)}
                                        one={intl.formatMessage({ id: 'common.unitDayOdd' })}
                                        other={intl.formatMessage({ id: 'common.unitDayPlural' })}
                                    />
                                }}
                            />
                        </span>
                    </div>
                </section>
                <section className={styles.packageInfo}>
                    <p style={{ marginTop: 0 }}>
                        <FormattedMessage id="home.flowUse.dataPlan.key" />:
                        <span>{simInfo.planName}</span>
                    </p>
                    <p>
                        <FormattedMessage id="home.flowUse.validity.key" />:
                        <span>
                            {`${formatDate(simInfo.startDate)} - ${formatDate(simInfo.endDate)} UTC`}
                        </span>
                    </p>
                    <p>
                        <FormattedMessage id="home.flowUse.note.key" />:
                        <span>
                            <FormattedMessage id="home.flowUse.note" />
                        </span>
                    </p>
                </section>
                {/*当前套餐及加油包记录*/}
                <DotTitle messageId={simInfo.operatorsId === OPERATOR_V.HUE ? "home.flowUse.currentDataPlan.titleHue" : "home.flowUse.currentDataPlan.title"} />
                <section className={styles.currentDataPlanWrap}>
                    <div className={styles.packageName}>
                        <span>{simInfo.planName}</span>
                        <img src={IconUsing} />
                    </div>
                    <WingBlank>
                        <div className={styles.packageInfoWrap}>
                            <p>
                                {countTotalFlowData({ goodsNumber, policyDegree })}
                            </p>
                            <span style={{ display: 'block', marginTop: '-5px', marginBottom: '5px' }}>
                                {
                                    unit === '0' && goodsTime > 1 && <span>{filterFlowUnit(policyDegree)}/{preMonth}</span>
                                }
                            </span>
                            <span>
                                {`${formatDate(simInfo.startDate, 'time').timeDateStr} - ${formatDate(simInfo.endDate, 'time').timeDateStr} UTC`}
                            </span>
                        </div>
                        {
                            Object.keys(this.props.refuelPackageOrderRecord).length > 0 &&
                            <div className={`${styles.packageInfoWrap} ${styles.flowAddWrap}`}>
                                <p style={{ color: '#6E3C0F' }}>
                                    <FormattedMessage id="package.expand.add" /> {filterFlowUnit(addFlow)}
                                </p>
                                <span>
                                    <FormattedMessage
                                        id="package.validTo"
                                        values={{ date: formatDate(this.props.refuelPackageEndDate, 'time').timeDateStr }}
                                    />
                                </span>
                            </div>
                        }
                    </WingBlank>
                </section>
            </>
        )
    }
}

export default FlowUse
